import { observer } from 'mobx-react';
import * as React from 'react';
import { Draggable } from '@hello-pangea/dnd';
import LearningCollectionEditStore from '../../../Edit/Store';
import { browseAllContext } from '../../../Types';
import CustomizeRow from '../Experiences/CustomizeRow';

interface Props {
  learningCollectionStore: LearningCollectionEditStore;
}

const OnDemandExperiences: React.FC<Props> = ({ learningCollectionStore }) =>
  learningCollectionStore.onDemandExperienceStores.map((experienceStore, index) => (
    <Draggable
      index={index}
      key={experienceStore.experienceResource.payload.id}
      draggableId={String(experienceStore.experienceResource.payload.id)}
    >
      {(provided) => (
        <tr
          className="border-b border-l-1 border-r-1"
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <CustomizeRow
            context={browseAllContext()}
            store={learningCollectionStore}
            experienceResource={experienceStore.experienceResource}
            dragHandleProps={provided.dragHandleProps}
          />
        </tr>
      )}
    </Draggable>
  ));

export default observer(OnDemandExperiences);
